import { takeLatest } from 'redux-saga/effects';

import { addToRootSaga } from 'store';
import { actionTypes } from '../actions';
import createListSaga from './createListSaga';
import createWorkflowDraftSaga from './createWorkflowDraftSaga';
import fetchAdditionalWorkflowDataSaga, {
  fetchVisitorCountsRequestSaga,
} from './fetchAdditionalWorkflowDataSaga';
import fetchBetaNodesSaga from './fetchBetaNodesSaga';
import fetchEventFieldMappingsSaga from './fetchEventFieldMappingsSaga';
import fetchFbCustomAudienceSaga from './fetchFbCustomAudienceSaga';
import fetchSendMetricsSaga from './fetchSendMetricsSaga';
import fetchTopLevelCustomEventsSaga from './fetchTopLevelCustomEventsSaga';
import fetchWorkflowSaga from './fetchWorkflowSaga';
import openNodeSaga from './openNodeSaga';
import publishWorkflowDraftSaga from './publishWorkflowDraftSaga';
import resetWorkflowDraftSaga from './resetWorkflowDraftSaga';
import saveWorkflowDraftSaga from './saveWorkflowDraftSaga';
import sendTestTriggerSaga from './sendTestTriggerSaga';
import updateWorkflowStatusSaga from './updateWorkflowStatusSaga';
import upsertWorkflowCampaignSaga from './upsertWorkflowCampaignSaga';
import { fetchJourneyVisitorMetricsSaga } from './fetchJourneyVisitorMetricsSaga';

addToRootSaga([
  takeLatest(actionTypes.CREATE_LIST_REQUEST, createListSaga),
  takeLatest(actionTypes.CREATE_WORKFLOW_DRAFT_REQUEST, createWorkflowDraftSaga),
  takeLatest(actionTypes.FETCH_BETA_NODES_REQUEST, fetchBetaNodesSaga),
  takeLatest(actionTypes.FETCH_EVENT_FIELD_MAPPINGS_REQUEST, fetchEventFieldMappingsSaga),
  takeLatest(actionTypes.FETCH_FB_CUSTOM_AUDIENCE_REQUEST, fetchFbCustomAudienceSaga),
  takeLatest(actionTypes.FETCH_SEND_METRICS_REQUEST, fetchSendMetricsSaga),
  takeLatest(actionTypes.FETCH_TOP_LEVEL_CUSTOM_EVENTS_REQUEST, fetchTopLevelCustomEventsSaga),
  takeLatest(actionTypes.FETCH_WORKFLOW_REQUEST, fetchWorkflowSaga),
  takeLatest(actionTypes.FETCH_WORKFLOW_RESPONSE, fetchAdditionalWorkflowDataSaga),
  takeLatest(actionTypes.FETCH_JOURNEY_VISITOR_METRICS_REQUEST, fetchJourneyVisitorMetricsSaga),
  takeLatest(actionTypes.FETCH_VISITOR_COUNTS_REQUEST, fetchVisitorCountsRequestSaga),
  takeLatest(actionTypes.OPEN_NODE_REQUEST, openNodeSaga),
  takeLatest(actionTypes.PUBLISH_WORKFLOW_DRAFT_REQUEST, publishWorkflowDraftSaga),
  takeLatest(actionTypes.RESET_WORKFLOW_DRAFT_REQUEST, resetWorkflowDraftSaga),
  takeLatest(actionTypes.SAVE_WORKFLOW_DRAFT_REQUEST, saveWorkflowDraftSaga),
  takeLatest(actionTypes.TEST_TRIGGER_REQUEST, sendTestTriggerSaga),
  takeLatest(actionTypes.UPDATE_WORKFLOW_STATUS_REQUEST, updateWorkflowStatusSaga),
  takeLatest(actionTypes.UPSERT_WORKFLOW_CAMPAIGN_REQUEST, upsertWorkflowCampaignSaga),
]);

export { default as createListSaga } from './createListSaga';
export { default as createWorkflowDraftSaga } from './createWorkflowDraftSaga';
export {
  default as fetchAdditionalWorkflowDataSaga,
  fetchVisitorCountsRequestSaga,
} from './fetchAdditionalWorkflowDataSaga';
export { default as fetchBetaNodesSaga } from './fetchBetaNodesSaga';
export { default as fetchEventFieldMappingsSaga } from './fetchEventFieldMappingsSaga';
export { default as fetchFbCustomAudienceSaga } from './fetchFbCustomAudienceSaga';
export { default as fetchSendMetricsSaga } from './fetchSendMetricsSaga';
export { default as fetchTopLevelCustomEventsSaga } from './fetchTopLevelCustomEventsSaga';
export { default as fetchWorkflowSaga } from './fetchWorkflowSaga';
export { fetchJourneyVisitorMetricsSaga } from './fetchJourneyVisitorMetricsSaga';
export { default as openNodeSaga } from './openNodeSaga';
export { default as publishWorkflowDraftSaga } from './publishWorkflowDraftSaga';
export { default as resetWorkflowDraftSaga } from './resetWorkflowDraftSaga';
export { default as saveWorkflowDraftSaga } from './saveWorkflowDraftSaga';
export { default as sendTestTriggerSaga } from './sendTestTriggerSaga';
export { default as updateWorkflowStatusSaga } from './updateWorkflowStatusSaga';
export { default as upsertWorkflowCampaignSaga } from './upsertWorkflowCampaignSaga';
